// @ts-nocheck

export const localeCodes =  [
  "de"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46js_f6d0e469",
      load: () => import("#nuxt-i18n/f6d0e469" /* webpackChunkName: "locale_de_46js_f6d0e469" */),
      cache: true
    },
    {
      key: "locale_de_46js_22678c34",
      load: () => import("#nuxt-i18n/22678c34" /* webpackChunkName: "locale_de_46js_22678c34" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  }
]

